import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { EASE } from "@/App";
import { MRCS, slugify } from "@/data/villes";

export default function Secteurs() {
  return (
    <section
      id="secteurs"
      data-testid="secteurs-section"
      className="py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          className="uppercase tracking-[0.25em] text-xs text-[#D1BFAE]"
        >
          Secteurs desservis
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: EASE, delay: 0.1 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl leading-tight mt-6 max-w-3xl"
        >
          Rive-Nord, Laurentides et Saint-Jérôme —{" "}
          <em className="text-[#D1BFAE]">de ville en ville</em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE, delay: 0.2 }}
          className="text-[#C4C9CE] text-base sm:text-lg leading-relaxed mt-6 max-w-2xl"
        >
          Cliquez sur votre municipalité pour découvrir nos services de
          rénovation de salle de bain près de chez vous.
        </motion.p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 mt-16">
          {MRCS.map((g) => (
            <motion.div
              key={g.mrc}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 1, ease: EASE }}
            >
              <h3 className="font-display text-xl text-[#D1BFAE]">{g.mrc}</h3>
              <ul className="mt-4 space-y-2">
                {g.villes.map((v) => (
                  <li key={v}>
                    <Link
                      to={`/renovation-salle-de-bain/${slugify(v)}`}
                      data-testid={`secteur-${slugify(v)}`}
                      className="text-sm text-[#C4C9CE] hover:text-[#D1BFAE] transition-colors duration-300"
                    >
                      Rénovation salle de bain {v}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
